import React from 'react';
import { useLocation } from 'react-router-dom';
import AuthHero from '../components/auth/AuthHero';
import AuthAppDownload from '../components/auth/AuthAppDownload';

const variantFromPath = (pathname, sa) => {
  if (sa) return 'sa-login';
  if (pathname.startsWith('/register/user')) return 'user-register';
  if (pathname.startsWith('/register'))      return 'register';
  if (pathname && pathname !== '/' && pathname.split('/').filter(Boolean).length === 1 && !['login', 'register', 'sa'].includes(pathname.replace(/^\/+/, ''))) {
    return 'college-register';
  }
  return 'login';
};

export default function AuthLayout({ children, sa }) {
  const { pathname } = useLocation();
  const variant = variantFromPath(pathname, sa);

  return (
    <div className={`auth-shell ${variant === 'login' ? 'auth-shell--login' : ''}`}>
      <div className="auth-grid"></div>
      <AuthHero variant={variant} />
      {variant === 'login' && (
        <div className="auth-app-download-slot">
          <AuthAppDownload />
        </div>
      )}
      <main className="auth-form-pane">
        {children}
      </main>
    </div>
  );
}
